module.exports = __webpack_public_path__ + "img/right.5bede857.svg";